import React from 'react';
import { createPortal } from 'react-dom';
import './Modal.scss';

const Modal = ({ isOpen, onClose, imageUrl }) => {
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M5.52205 18.4834L5.6949 18.3106L5.52205 18.4834C5.90963 18.871 6.53802 18.871 6.9256 18.4834L11.9988 13.4102L17.0721 18.4834C17.4596 18.871 18.088 18.871 18.4756 18.4834C18.8632 18.0958 18.8632 17.4674 18.4756 17.0799L13.4024 12.0066L18.4756 6.93342C18.8632 6.54584 18.8632 5.91744 18.4756 5.52986L18.3008 5.7047L18.4756 5.52986C18.088 5.14228 17.4596 5.14228 17.0721 5.52986L11.9988 10.6031L6.9256 5.52986C6.53802 5.14228 5.90963 5.14228 5.52205 5.52986C5.13447 5.91744 5.13447 6.54584 5.52205 6.93342L10.5953 12.0066L5.52205 17.0799C5.13447 17.4674 5.13447 18.0958 5.52205 18.4834Z"
              fill="#090808"
              stroke="#090808"
              strokeWidth="0.5"
            />
          </svg>
        </button>
        <img src={imageUrl} alt="Modal" className="modal-image" />
      </div>
    </div>,
    document.body
  );
};

export default Modal;
